module.exports = __webpack_public_path__ + "img/Workflow-ability-06.8763733f.png";